// import React from "react";
import HealthTwoBanner from "../../healthTwoComponents/HealthTwoBanner";
import HealthTwoCategory from "../../healthTwoComponents/HealthTwoCategory";
import HealthTwoBestDeals from "../../healthTwoComponents/HealthTwoBestDeals";
import HealthTwoPrescriptions from "../../healthTwoComponents/HealthTwoPrescriptions";
import HealthTwoFeaturedBrand from "../../healthTwoComponents/HealthTwoFeaturedBrand";
import HealthTwoProducts from "../../healthTwoComponents/HealthTwoProducts";
import HealthTwoPromotions from "../../healthTwoComponents/HealthTwoPromotions";
import HealthTwoFoodCollection from "../../healthTwoComponents/HealthTwoFoodCollection";
import HealthTwoTopCereal from "../../healthTwoComponents/HealthTwoTopCereal";
import HealthTwoCustomerReviews from "../../healthTwoComponents/HealthTwoCustomerReviews";
import HealthTwoGotFAQ from "../../healthTwoComponents/HealthTwoGotFAQ";
import HealthTwoAppDownload from "../../healthTwoComponents/HealthTwoAppDownload";
import HealthTwoFooter from "../../healthTwoComponents/HealthTwoFooter";
import HealthTwoStories from "../../healthTwoComponents/HealthTwoStories";

const HealthTwoHome = () => {
  return (
    <div>
      <HealthTwoBanner />
      <HealthTwoCategory /> <HealthTwoBestDeals />
      <HealthTwoPrescriptions />
      <HealthTwoFeaturedBrand />
      <HealthTwoProducts />
      <HealthTwoPromotions />
       <HealthTwoStories/>
      <HealthTwoFoodCollection />
      <HealthTwoTopCereal />
      <HealthTwoCustomerReviews />
      <HealthTwoGotFAQ />
      <HealthTwoAppDownload />
      <HealthTwoFooter />
      
    </div>
  );
};

export default HealthTwoHome;
